import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { NavBar } from "..";
import styles from "./styles.module.scss";
import CheckoutConfirmExpress from "./CheckoutConfirmExpress";
import CheckoutOrderSummary from "./CheckoutOrderSummary";
import { useEffect } from "react";
import { fetchPricing, setShowOTB } from "Root/checkout/redux/slices/checkoutPricingSlice";
import { useDispatch, useSelector } from "react-redux";
import CheckoutConfirmShipping from "./CheckoutConfirmShipping";
import { LoadRegisteredDietitianThunk } from "Root/profile/redux/thunkCreators/dietitian/registeredDietitian";
import CheckoutConfirmPayment from "./CheckoutConfirmPayment";
import H2Font from "Root/profile/components/common/H2Font";
import posthog from "posthog-js";
import PlanSelect from "./PlanSelect";
import { apiGetABtest } from "Root/api/apiCommon";
import { setIsEditPlanSelect, setEditPaymentMethod, setEditShippingAddress, setEditShippingMethod, } from "Root/checkout/redux/slices/checkoutComponentSlice";
const CheckoutConfirmNew = () => {
    const dispatch = useDispatch();
    const userCart = useSelector((state) => state.checkoutUserCart.userCart);
    const bannerData = useSelector((state) => state.checkoutComponent.bannerData);
    const componentState = useSelector((state) => state.checkoutComponent);
    const data = useSelector((state) => state.checkoutShipping.address);
    const showOTB = useSelector((state) => state.checkoutPricing.showOTB);
    const getAbTestResults = async () => {
        const result = await apiGetABtest("show-otb");
        // const result = "1";
        if (result !== "1") {
            document.getElementById("shipping-address")?.scrollIntoView({ block: "nearest", behavior: "smooth" });
            dispatch(setIsEditPlanSelect(false));
            dispatch(setEditPaymentMethod(false));
            dispatch(setEditShippingAddress(true));
            dispatch(setEditShippingMethod(false));
        }
        dispatch(setShowOTB(result === "1"));
        posthog.capture("AB_TEST", { $set_once: { "show-otb": result } });
    };
    useEffect(() => {
        getAbTestResults();
        window.scrollTo(0, 0);
        posthog?.capture("$pageview");
        dispatch(LoadRegisteredDietitianThunk());
    }, []);
    useEffect(() => {
        if (userCart?.length > 0 && !componentState.isUpdatingCart) {
            dispatch(fetchPricing(data.shipping_method || "standard"));
        }
    }, [userCart]);
    return (_jsxs(_Fragment, { children: [_jsx(NavBar, { active: 4, cart: userCart, isBottomHidden: true, bannerData: bannerData }), _jsxs("div", { className: styles.checkoutHero, children: [_jsx(H2Font, { fontWeight: 400, className: styles.checkoutHed, children: "Checkout" }), _jsx("div", { className: styles.moneyback, children: "30 Day Money Back Guarantee" })] }), _jsxs("div", { className: styles.checkout_confirm, children: [_jsxs("div", { className: styles.checkout, children: [showOTB && _jsx(PlanSelect, {}), componentState.isEditShippingAddress &&
                                !componentState.isInfluencer &&
                                !componentState.isUpdatingCart &&
                                !componentState.isEditPlanSelect && (_jsx(_Fragment, { children: _jsx(CheckoutConfirmExpress, {}) })), _jsx(CheckoutConfirmShipping, {}), _jsx(CheckoutConfirmPayment, {})] }), _jsx(CheckoutOrderSummary, {})] })] }));
};
export default CheckoutConfirmNew;
